"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSelect = exports.Row = exports.DropDownContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Form = require("../Form");

var _theme = require("../../theme");

const DropDownContainer = _styledComponents.default.div.withConfig({
  displayName: "TimePickerstyles__DropDownContainer"
})(["margin-top:", ";"], (0, _theme.spacing)(0.5));

exports.DropDownContainer = DropDownContainer;

const Row = _styledComponents.default.div.withConfig({
  displayName: "TimePickerstyles__Row"
})(["display:flex;align-items:center;gap:", ";"], (0, _theme.spacing)(0.25));

exports.Row = Row;
const TimeSelect = (0, _styledComponents.default)(_Form.Select).withConfig({
  displayName: "TimePickerstyles__TimeSelect"
})(["max-height:30vh;min-width:", ";"], (0, _theme.spacing)());
exports.TimeSelect = TimeSelect;
TimeSelect.defaultProps = {
  isContentSameWidthAsInput: true,
  arrowPosition: 'right'
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEcm9wRG93bkNvbnRhaW5lciIsInN0eWxlZCIsImRpdiIsInNwYWNpbmciLCJSb3ciLCJUaW1lU2VsZWN0IiwiU2VsZWN0IiwiZGVmYXVsdFByb3BzIiwiaXNDb250ZW50U2FtZVdpZHRoQXNJbnB1dCIsImFycm93UG9zaXRpb24iXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UaW1lUGlja2VyL1RpbWVQaWNrZXIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnc3R5bGVkLWNvbXBvbmVudHMnXG5pbXBvcnQgeyBTZWxlY3QgfSBmcm9tICd+Y29tcG9uZW50cy9Gb3JtJ1xuaW1wb3J0IHsgc3BhY2luZyB9IGZyb20gJ350aGVtZSdcblxuZXhwb3J0IGNvbnN0IERyb3BEb3duQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luLXRvcDogJHtzcGFjaW5nKDAuNSl9O1xuYFxuXG5leHBvcnQgY29uc3QgUm93ID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiAke3NwYWNpbmcoMC4yNSl9O1xuYFxuXG5leHBvcnQgY29uc3QgVGltZVNlbGVjdCA9IHN0eWxlZChTZWxlY3QpYFxuICBtYXgtaGVpZ2h0OiAzMHZoO1xuICBtaW4td2lkdGg6ICR7c3BhY2luZygpfTtcbmBcblxuVGltZVNlbGVjdC5kZWZhdWx0UHJvcHMgPSB7XG4gIGlzQ29udGVudFNhbWVXaWR0aEFzSW5wdXQ6IHRydWUsXG4gIGFycm93UG9zaXRpb246ICdyaWdodCcsXG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUVPLE1BQU1BLGlCQUFpQixHQUFHQyx5QkFBQSxDQUFPQyxHQUFWO0VBQUE7QUFBQSx5QkFDZCxJQUFBQyxjQUFBLEVBQVEsR0FBUixDQURjLENBQXZCOzs7O0FBSUEsTUFBTUMsR0FBRyxHQUFHSCx5QkFBQSxDQUFPQyxHQUFWO0VBQUE7QUFBQSxrREFHUCxJQUFBQyxjQUFBLEVBQVEsSUFBUixDQUhPLENBQVQ7OztBQU1BLE1BQU1FLFVBQVUsR0FBRyxJQUFBSix5QkFBQSxFQUFPSyxZQUFQLENBQUg7RUFBQTtBQUFBLHdDQUVSLElBQUFILGNBQUEsR0FGUSxDQUFoQjs7QUFLUEUsVUFBVSxDQUFDRSxZQUFYLEdBQTBCO0VBQ3hCQyx5QkFBeUIsRUFBRSxJQURIO0VBRXhCQyxhQUFhLEVBQUU7QUFGUyxDQUExQiJ9